export const getTrend = (current, previous) => {
  if (
    typeof current !== 'number' ||
    typeof previous !== 'number' ||
    Number.isNaN(current) ||
    Number.isNaN(previous)
  ) {
    return 'equal';
  }

  if (current > previous) return 'up';
  if (current < previous) return 'down';
  return 'equal';
};
